import React, { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaTrash, FaCheck } from "react-icons/fa";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Editor from '@monaco-editor/react';
import Paginacao from '../../common/pagination';

class ModeloRelatorio extends Component {
    constructor(props) {
        super(props);

        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listModelosRelatorio: [],
            loading: true,
            loadingModal: false,
            error: '',
            page_numb: 1,
            
            // Modal
            showModal: false,
            modalTitulo: '',
            modeloRelatorioEditando: null,
            
            // Campos do formulário
            id: null,
            tipos: [],

            nome: '',
            layout: '',
            nivelPermissaoJson: '[]',
            filtrosJson: '[]',
            camposJson: '[]',
            
            // Erros de validação
            nivelPermissaoJsonError: '',
            filtrosJsonError: '',
            camposJsonError: '',
        };

    }

    componentDidMount() {
        this.CarregarModelosRelatorio(this.state.page_numb);
    }

    CarregarModelosRelatorio = (page_numb = 1) => {
        const { programaId } = this.props;

        if (!programaId) {
            this.setState({ loading: false, error: 'ID do programa não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        api.get(`/relatorios/modelos/?programa_id=${programaId}&page=${page_numb}`)
            .then(response => {
                this.setState({
                    listModelosRelatorio: response.data,
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao carregar modelos de relatório do programa';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg,
                });
            });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.CarregarModelosRelatorio(num_page);
    }

    // Gera um resumo legível do JSON
    gerarResumoJson = (json, maxLength = 80) => {
        if (!json || (Array.isArray(json) && json.length === 0) || (typeof json === 'object' && Object.keys(json).length === 0)) {
            return <span className="text-muted">Vazio</span>;
        }

        try {
            let resumo = '';

            if (Array.isArray(json)) {
                // Se for array, mostra quantidade e preview dos primeiros itens
                const qtd = json.length;
                const preview = json.slice(0, 2).map(item => {
                    if (typeof item === 'object' && item !== null) {
                        // Pega as primeiras chaves do objeto
                        const keys = Object.keys(item).slice(0, 3);
                        return keys.map(k => `${k}: ${this.formatarValor(item[k])}`).join(', ');
                    }
                    return String(item);
                }).join(' | ');

                resumo = `[${qtd} item${qtd > 1 ? 's' : ''}] ${preview}`;
            } else if (typeof json === 'object') {
                // Se for objeto, mostra as primeiras chaves e valores
                const keys = Object.keys(json).slice(0, 4);
                resumo = keys.map(k => `${k}: ${this.formatarValor(json[k])}`).join(', ');
            } else {
                resumo = String(json);
            }

            // Trunca se muito longo
            if (resumo.length > maxLength) {
                resumo = resumo.substring(0, maxLength) + '...';
            }

            return <span title={JSON.stringify(json, null, 2)}>{resumo}</span>;
        } catch (e) {
            return <span className="text-muted">Erro ao ler JSON</span>;
        }
    };

    formatarValor = (valor) => {
        if (valor === null || valor === undefined) return 'null';
        if (typeof valor === 'boolean') return valor ? 'true' : 'false';
        if (typeof valor === 'object') return Array.isArray(valor) ? `[${valor.length}]` : '{...}';
        if (typeof valor === 'string' && valor.length > 20) return valor.substring(0, 20) + '...';
        return String(valor);
    };

    abrirModalNovo = () => {
        this.setState({
            showModal: true,
            modalTitulo: 'Adicionar Modelos de Relatório',
            modeloRelatorioEditando: null,
            id: null,
            tipos: [],
            camposJson: '[]',
            camposJsonError: '',
            nivelPermissaoJson: '[]',
            nivelPermissaoJsonError: '',
            filtrosJson: '[]',
            filtrosJsonError: '',
        });
    };

    abrirModalEditar = (modeloRelatorio) => {
        // Converte string de tipos para array
        this.setState({
            showModal: true,
            modalTitulo: 'Editar Modelos de Relatório',
            modeloRelatorioEditando: modeloRelatorio,
            id: modeloRelatorio.id,
            nome: modeloRelatorio.nome,
            layout: modeloRelatorio.layout,
            camposJson: modeloRelatorio.campos ? JSON.stringify(modeloRelatorio.campos, null, 4) : '[]',
            camposJsonError: '',
            nivelPermissaoJson: modeloRelatorio.nivel_permissao ? JSON.stringify(modeloRelatorio.nivel_permissao, null, 4) : '[]',
            nivelPermissaoJsonError: '',
            filtrosJson: modeloRelatorio.filtros ? JSON.stringify(modeloRelatorio.filtros, null, 4) : '[]',
            filtrosJsonError: '',
        });
    };

    fecharModal = () => {
        this.setState({
            showModal: false,
            modeloRelatorioEditando: null,
            id: null,
            nome: '',
            layout: '',
            nivel_permissao: '',
            filtros: '',
            camposJson: '[]',
            camposJsonError: '',
            nivelPermissaoJson: '[]',
            nivelPermissaoJsonError: '',
            filtrosJson: '[]',
            filtrosJsonError: '',
        });
    };

    onChangeNome = (e) => {
        this.setState({ nome: e.target.value });
    }

    onChangeLayout = (e) => {
        this.setState({ layout: e.target.value });
    }

    handleCamposJsonChange = (value) => {
        this.setState({ camposJson: value || '', camposJsonError: '' });
    };

    handleNivelPermissaoJsonChange = (value) => {
        this.setState({ nivelPermissaoJson: value || '', nivelPermissaoJsonError: '' });
    };

    handleFiltrosJsonChange = (value) => {
        this.setState({ filtrosJson: value || '', filtrosJsonError: '' });
    };

    validarFormulario = () => {
        let valido = true;

        // Validar JSON de campos
        try {
            JSON.parse(this.state.camposJson);
        } catch (e) {
            this.setState({ camposJsonError: 'JSON inválido. Verifique a sintaxe.' });
            valido = false;
        }

        // Validar JSON de permissão
        try {
            JSON.parse(this.state.nivelPermissaoJson);
        } catch (e) {
            this.setState({ nivelPermissaoJsonError: 'JSON inválido. Verifique a sintaxe.' });
            valido = false;
        }

        // Validar JSON de filtros
        try {
            JSON.parse(this.state.filtrosJson);
        } catch (e) {
            this.setState({ filtrosJsonError: 'JSON inválido. Verifique a sintaxe.' });
            valido = false;
        }

        return valido;
    };

    SalvarModeloRelatorio = async () => {
        if (!this.validarFormulario()) {
            return;
        }

        const { programaId } = this.props;
        const { id, camposJson, nivelPermissaoJson, filtrosJson } = this.state;

        this.setState({ loadingModal: true });

        const dados = {
            programa_id: programaId,
            nome: this.state.nome,
            layout: this.state.layout,
            nivel_permissao: JSON.parse(nivelPermissaoJson),
            filtros: JSON.parse(filtrosJson),
            campos: JSON.parse(camposJson)
        };

        const url = id ? `/relatorios/modelos/${id}/` : '/relatorios/modelos/';
        const metodo = id ? 'put' : 'post';

        try {
            await api({
                method: metodo,
                url: url,
                data: dados,
            });

            const MySwal = withReactContent(Swal);
            const textSwal = id ? 'Modelos de Relatório atualizado com sucesso' : 'Modelos de Relatório cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ loadingModal: false });
            this.fecharModal();
            this.CarregarModelosRelatorio(this.state.page_numb);

        } catch (error) {
            let erro_msg = 'Erro ao salvar Modelos de Relatório, verifique os campos e tente novamente';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                
                if (campos.campos) {
                    this.setState({ camposJsonError: campos.campos });
                }
                if (campos.nivel_permissao) {
                    this.setState({ nivelPermissaoJsonError: campos.nivel_permissao });
                }
                if (campos.filtros) {
                    this.setState({ filtrosJsonError: campos.filtros });
                }
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });

            this.setState({ loadingModal: false });
        }
    };

    excluirModeloRelatorio = (modeloRelatorio) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Você tem certeza?',
            text: 'Esta ação não pode ser desfeita!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await api.delete(`/relatorios/modelos/${modeloRelatorio.id}/`);

                    MySwal.fire(
                        'Excluído!',
                        'Modelo de Relatório foi excluído com sucesso.',
                        'success'
                    );

                    this.CarregarModelosRelatorio(this.state.page_numb);

                } catch (error) {
                    let erro_msg = 'Erro ao excluir Modelo de Relatório';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: erro_msg,
                    });
                }
            }
        });
    };

    renderRows = () => {
        if ('results' in this.state.listModelosRelatorio && this.state.listModelosRelatorio.results.length > 0) {
            return this.state.listModelosRelatorio.results.map((modeloRelatorio) => (
                <tr key={modeloRelatorio.id}>
                    <td>{modeloRelatorio.id}</td>
                    <td>{modeloRelatorio.nome}</td>
                    <td style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {this.gerarResumoJson(modeloRelatorio.campos)}
                    </td>
                    <td>{modeloRelatorio.layout}</td>
                    <td>
                        <Button variant="light" size="sm"  className="me-1" onClick={() => this.abrirModalEditar(modeloRelatorio)}>
                            <FaRegEdit /> Editar
                        </Button>
                        <Button variant="danger" size="sm" onClick={() => this.excluirModeloRelatorio(modeloRelatorio)}>
                            <FaTrash /> Excluir
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={5}>Nenhum modelo relatório cadastrado para este programa</td>
            </tr>
        );
    };

    render() {
        const { 
            loading, 
            loadingModal,
            error, 
            showModal, 
            modalTitulo,
            camposJson,
            camposJsonError,
            nivelPermissaoJson,
            nivelPermissaoJsonError,
            filtrosJson,
            filtrosJsonError,
            listModelosRelatorio,
            page_numb,
        } = this.state;

        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h4>Modelos de Relatório do Programa</h4>
                            </Col>
                            <Col sm={6} lg={6} className="text-end">
                                <Button variant="secondary" size="sm" onClick={this.abrirModalNovo}>
                                    <FaPlus /> Adicionar Modelos de Relatório
                                </Button>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Campos</th>
                                    <th>Layout</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={5}>Carregando...</td>
                                    </tr>
                                ) : (
                                    error ? (
                                        <tr>
                                            <td colSpan={5}>{error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>

                        {'results' in listModelosRelatorio && listModelosRelatorio.results.length > 0 && 
                            <Paginacao  dados={listModelosRelatorio}  loading={loading} page_numb={page_numb}  _onClickPagina={this.onClickPagina} />
                        }
                    </Card.Body>
                </Card>

                {/* Modal de Cadastro/Edição */}
                <Modal show={showModal} onHide={this.fecharModal} size="xl" backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="nome"
                                            value={this.state.nome}
                                            onChange={this.onChangeNome}
                                            placeholder="Nome"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Layout</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="layout"
                                            value={this.state.layout}
                                            onChange={this.onChangeLayout}
                                            placeholder="Layout"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>  

                            <Form.Group className="mb-3">
                                <Form.Label>Campos (JSON)</Form.Label>
                                {camposJsonError && (
                                    <Alert variant="danger" className="py-1 mb-2">{camposJsonError}</Alert>
                                )}
                                <Editor
                                    height="250px"
                                    defaultLanguage="json"
                                    value={camposJson}
                                    onChange={this.handleCamposJsonChange}
                                    theme="vs-dark"
                                    options={{
                                        minimap: { enabled: false },
                                        fontSize: 14,
                                        formatOnPaste: true,
                                        formatOnType: true,
                                        automaticLayout: true,
                                        tabSize: 4,
                                    }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Nível de Permissão (JSON)</Form.Label>
                                {nivelPermissaoJsonError && (
                                    <Alert variant="danger" className="py-1 mb-2">{nivelPermissaoJsonError}</Alert>
                                )}
                                <Editor
                                    height="250px"
                                    defaultLanguage="json"
                                    value={nivelPermissaoJson}
                                    onChange={this.handleNivelPermissaoJsonChange}
                                    theme="vs-dark"
                                    options={{
                                        minimap: { enabled: false },
                                        fontSize: 14,
                                        formatOnPaste: true,
                                        formatOnType: true,
                                        automaticLayout: true,
                                        tabSize: 4,
                                    }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Filtros (JSON)</Form.Label>
                                {filtrosJsonError && (
                                    <Alert variant="danger" className="py-1 mb-2">{filtrosJsonError}</Alert>
                                )}
                                <Editor
                                    height="250px"
                                    defaultLanguage="json"
                                    value={filtrosJson}
                                    onChange={this.handleFiltrosJsonChange}
                                    theme="vs-dark"
                                    options={{
                                        minimap: { enabled: false },
                                        fontSize: 14,
                                        formatOnPaste: true,
                                        formatOnType: true,
                                        automaticLayout: true,
                                        tabSize: 4,
                                    }}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModal}>
                            Cancelar
                        </Button>
                        <Button 
                            variant="success" 
                            onClick={this.SalvarModeloRelatorio}
                            disabled={loadingModal}
                        >
                            {loadingModal ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ModeloRelatorio;
